module.exports = __webpack_public_path__ + "img/monster-2.968f1b14.png";